module.exports = __webpack_public_path__ + "img/電気回路_6_2_3.591b6d1b.png";